import type { MouseEvent } from 'react';

export type TopicLinkProps = {
  name?: string | null;
  topicName?: string | null;
  subTopicName?: string | null;
  separator?: string;
  href?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  variant?: 'body1' | 'body1Emphasis' | 'body2' | 'body2Emphasis' | 'caption';
  color?: string;
  underline?: 'none' | 'hover' | 'always';
  noWrap?: boolean;
  'data-testid'?: string;
};

export function useTopicLink(props: TopicLinkProps) {
  const isClickable = Boolean(props.href || props.onClick);
  const variant = props.variant ?? 'body2';
  const underline = props.underline ?? 'hover';

  const separator = props.separator ?? ' > ';
  let displayText = '';

  if (props.topicName && props.subTopicName) {
    displayText = `${props.topicName}${separator}${props.subTopicName}`;
  } else if (props.name) {
    displayText = props.name;
  } else if (props.subTopicName) {
    displayText = props.subTopicName;
  } else if (props.topicName) {
    displayText = props.topicName;
  }

  function handleClick(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    props.onClick?.(event);
  }

  return {
    isClickable,
    variant,
    underline,
    handleClick,
    displayText: displayText.trim(),
  };
}
